/* ADRESY PODLE ZEMĚ TENANTA (nález CRM-SK-03, 18. 10. 2026).
 *
 * Našeptávač adres hledal natvrdo v ČR (Nominatim countrycodes=cz, jazyk cs)
 * a složka klienta ukazovala „Česká republika" / „GPS: Košice, ČR" i u
 * slovenského poradce a klienta. Země se bere ze ZEMĚ TENANTA (ne z jazyka
 * appky) — stejný zdroj jako měna, viz lib/tenantMena.js.
 * Zrcadlí ADRESY_ZEME v backend/routes/mapy.py (Mapy.com proxy + geokódování).
 */
import { normZeme, zemeTenanta } from "@/lib/tenantMena";

export const ADRESY_ZEME = {
  CZ: { kod: "cz", jazyk: "cs", nazev: "Česká republika", zkratka: "ČR" },
  SK: { kod: "sk", jazyk: "sk", nazev: "Slovensko", zkratka: "SR" },
};

/** Parametry adres pro zemi (bez argumentu země tenanta). Vždy objekt. */
export function adresyZeme(zeme) {
  return ADRESY_ZEME[normZeme(zeme ?? zemeTenanta())];
}

/** URL záložního hledání v OSM Nominatim — jen v zemi tenanta. */
export function nominatimUrl(q, zeme) {
  const z = adresyZeme(zeme);
  return `https://nominatim.openstreetmap.org/search?format=json&q=${encodeURIComponent(q)}&countrycodes=${z.kod}&limit=6&addressdetails=1`;
}
